import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'

//var dateFormat = require('dateformat');



const RenderWpForm = () => {
var md5 = require('md5');
let resturl='';


//var boolFetchingSads=false;

const navigate = useNavigate();


const [progress, setProgress] = useState({
perct:null
});
const [selectedFiles, setSelectedFiles] = useState([]);
const [agencyoptions, setAgencyoptions] = useState([]);

const [dowait, setDowait] = useState({show:false});

const [idtype, setIdtype] = useState([
<option key='lsta1' value=''></option>
,<option key='lsta2' value='TCI Belonger Card'>TCI Belonger Card</option>
,<option key='lsta3' value='TCI Residence Card'>TCI Residence Card</option>
,<option key='lsta4' value='Passport'>Passport</option>
,<option key='lsta5' value='Driver License'>Driver License</option>
,<option key='lsta6' value='NIB or NHIB Card'>NIB or NHIB Card</option>
,<option key='lsta7' value='Other Id'>Other Id</option>
]);


const [pwd, setPwd] = useState({
	ok:false
	,req1:false
	,req2:false
	,req3:false
	,req4:false
	,req5:false
	});



const [webuser, setWebuser] = useState({
EMAIL:''
,PHONE:''
,FULLNAME:''
,ID_TYPE:''
,STAMP:''
,AGENCYID:''
,PWD:''
,PHOTO_FILE_NAME:''
,regSubmitted:false
});


const location = useLocation();


useEffect(() => {
//getwebuser();
if (!location.state){
	navigate("/login");
	return;
	}
	
resturl=location.state.RESTURL;
console.log('location.state.RESTURL: '+location.state.RESTURL);

//setWebuser((prev)=>{return {...prev, EMAIL:location.state.EMAIL}});
//document.getElementsByTagName('body')[0].classList.delete("loginbody");
getagencyoptions();

//webuser.EMAIL

addSubmitEventListener('form1', null);
 },[]);


useEffect(() => {
	if (agencyoptions.length>0){
		openCity("regform");
		document.getElementsByName('EMAIL')[0].focus();
		}//end if

},[JSON.stringify(agencyoptions)]);

useEffect(() => {

if (!location.state){
	return;
	}
	
if (location.state.RESTURL!=undefined)
	if (location.state.RESTURL!=null)
		resturl=location.state.RESTURL;

if (resturl=='' && sessionStorage.getItem("RESTURL")!=undefined)
	resturl=sessionStorage.getItem("RESTURL");

 },[webuser]);


function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func

async function updatewebuser(e){
	//regfile
//e.preventDefault();

	if (selectedFiles.length==0){
		showsnackbar("file upload is requried");
		return;
		}

	if (pwd.ok==false){
		showsnackbar("the password must contain Capital and common letters and a number");
		return;
		}

const FULLNAME=(""+webuser.FULLNAME).trim();
if (FULLNAME.length<5 || !FULLNAME.includes(" ")){
		showsnackbar("please check that the full name is entered correctly");
		return;
		}

let temp=webuser;
temp.PWD=md5(webuser.PWD);
temp.PHOTO_FILE_NAME="reginfo."+selectedFiles[0].ext;

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {webuser:temp, USERNAME:sessionStorage.getItem("USERNAME")} )
  };	
  
  setDowait({show:true});
	
  await fetch(resturl+'rarwplogin/updatewebuser',requestOptions)
      .then(res => res.json())
      .then(res => 	{aftergetwebuser(res);  } )
      .catch(err => { setDowait({show:false}); console.log(err); });

	//console.log('aftergetwpapp: '+res[0].OCCUPATION);
}//end func

function webuserChange(e){
//const val=e.target.value;
var {name, value}=e.target;
console.log('webuserChange: '+name+", "+value)

if (name=="PHONE")
	value=value.replace(/\D/gm,"");//var reg = /^\d+$/;

setWebuser((prev) => {
return {...prev, [name]:value}
});	

if (name=="PWD")
	checkpassword(value.trim());

}//end func


function checkpassword(pwd1) {
  
  /*
  len, capital, common, number
  */
  //const pwd1=(""+webuser.PWD).trim();
  const pwdok=pwd1.length>5 && pwd1.length<25 && pwd1.match(/[A-Z]+/) && pwd1.match(/[a-z]+/) && pwd1.match(/[0-9]+/);
  console.log("checkpassword pwdok: "+pwdok);
  //console.log("pwd2: "+pwd2);
  setPwd((prev)=>{
	  return {...prev
	  , req1: pwd1.length>5 && pwd1.length<25
	  , req2: pwd1.match(/[A-Z]+/)
	  , req3: pwd1.match(/[a-z]+/)
	  , req4: pwd1.match(/[0-9]+/)
	  , ok: pwdok
	  }
  });
  
  
}//end func

async function getagencyoptions(res){
	//not sure why this was in the useEffect
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };	
	
  await fetch(resturl+'rarwpform/getagencyoptions',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetagencyoptions(res) )
      .catch(err => console.log(err));

}//end func

function aftergetagencyoptions(res){
	
if (!res.length)
	return;
	
let temp=[];

res.map((col, index) => {
	const key="agopts_"+index;
	
	temp.push(<option key={key} value={col['AGENCYID']}  >{col['AGENCY']}</option>);
	
	});//end map
setAgencyoptions(temp);

}//end func

function handleChange(e){
//const val=e.target.value;
console.log('e.target.value: '+e.target.value)
const {name, value}=e.target;

setWebuser((prev) => {
return {...prev, [name]:value}
});	
}//end func

async function uploadfiles(WEB_USER_FOLDER){
	console.log('uploadfiles: '+selectedFiles.length+', WEB_USER_FOLDER: '+WEB_USER_FOLDER);
	if (selectedFiles.length==0)
		return;
 const FormData = require('form-data'); // npm install --save form-data

const form = new FormData();

form.append('USERNAME', sessionStorage.getItem("USERNAME"));
form.append('REF_NUM', WEB_USER_FOLDER);

//let formfiles={foto:false,sign:false,scans:false};

const currfile=selectedFiles[0].file;
const ext=selectedFiles[0].ext;
let scansFile=new File([currfile], 'reginfo.'+ext);;
const filenames={scans:currfile.name};

form.append('REG_INFO', filenames.scans);

if (scansFile!=null)	{form.append('filesupload', scansFile);}

const request_config = {
    onUploadProgress: data => {
      //Set the progress value to show the progress bard
      setProgress({perct:Math.round((100 * data.loaded) / data.total)});
    },
};
await axios.post(resturl+'rarwpform/uploadregphotofile', form, request_config)
.then(res => afteruploadfiles(res.data));

	
}//end func

function afteruploadfiles(data){

openCity("confirm");
}//end func

function aftergetwebuser(res){

setDowait({show:false});

//setWebuser(res[0]);

if (res[0].USER_COUNT==0)
	uploadfiles(res[0].WEB_USER_FOLDER);
else
	showsnackbar("the email address provided is already in use");
	//openCity("confirm");

}//end func


function addSubmitEventListener(formId, callback){
	//console.log('addSubmitEventListener: '+formId);
	let form = document.getElementById(formId);
	// Eventlistener can be another event and on another DOM object this is just an example
	form.addEventListener('submit', function (event) {
		// Only needed if event is submit, otherwise this line can be skipped 
		event.preventDefault();

		// This is the important part, test if form is valid
		if (form.checkValidity() === false){
			// This is the magic function that displays the validation errors to the user
			form.reportValidity();   
			return; 
		}

	if (callback)
		callback(formId);

		// Code if all fields are valid; continue form submit or make Ajax call.
	});

}//end function


function checkregfileOld(event){
	


/*
var result=true;
var fileElement = document.getElementsByName("regfile")[0];
var fileExtension = "";
if (fileElement.value.lastIndexOf(".") > 0) {
	fileExtension = fileElement.value.substring(fileElement.value.lastIndexOf(".") + 1, fileElement.value.length);
	}
else
	result= false;

if (fileExtension.toLowerCase() == "pdf") {
	const newFile=new File([fileElement.files[0]], fileElement.files[0].name);
	console.log(' newFile.name.length: '+ newFile.name.length);
	console.log(' newFile.size: '+ newFile.size);
	result= newFile.name.length<121 && newFile.size<=2*1024*1024;
	}
else
	result= false;

if (result==false)
	fileElement.value='';

console.log('fileExtension: '+fileExtension);
return result;

*/	

}//end function

function selectedFilesChange(event){

if (event.target.files.length>1){
	showsnackbar("upload only one file please");
	return;
	}
else if (event.target.files.length==0)
	return;
	
const fileName=event.target.files[0].name;
var fileExtension = "";
if (fileName.lastIndexOf(".") > 0) 
	fileExtension = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length);

const lsExtension="png, jpg, jpeg, bmp, webp, gif";
if (!(", "+lsExtension).includes(", "+fileExtension)){
	document.getElementById("regfile").value='';
	showsnackbar("error: the uploaded file must have one of these extensions: "+lsExtension);
	return;
	}//end if		


	let temp=selectedFiles;
	temp[0]={file:event.target.files[0], ext:fileExtension};
	setSelectedFiles(temp);
	
	
}//end func


function openCity(cityName) {

//	currCity=cityName;

//console.log('openCity cityName: '+cityName);

  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  //console.log('tabcontent.length: '+tabcontent.length);
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
	tablinks[i].className = tablinks[i].className.replace(" active", "");
	

	}//end for
  document.getElementById(cityName).style.display = "block";
  if (cityName=="userreg"){
	  const email=document.getElementsByName('username')[0].value;
	  setWebuser((prev)=>{return {...prev, EMAIL:email}});
	  //document.getElementsByName('EMAIL')[0].value=;
	  document.getElementsByName('FULLNAME')[0].focus();
	}
  else if (cityName=="login")
	  document.getElementsByName('username')[0].focus();
 
  
}//end function

//upload valid TCI Id:in pdf format
//Work Permits Portal
  return (
    <>
	<div id="regform" className="tabcontent" style={{marginTop:"18px"}} >
		<div align="center" >
		<h3 style={{marginBottom:"0px"}} >Application Processing System User Registration</h3>
		</div>
		<p align='center' >An image file displaying your valid Passport or TCI photo identificaiton is required</p>
		{/* readOnly className="gnsbro" */}			
		<form method='POST' id='form1' onSubmit={(e)=>{updatewebuser(e);}} >
		<table align='center' border="0" >
		<tbody>
		<tr>
		<td align='right' >Email Address: </td>
		<td align='left' ><input name='EMAIL' type="email" required value={webuser.EMAIL} onChange={(e)=>{webuserChange(e);}} autoComplete='off' placeholder='email address' /></td>
		</tr>
		<tr>
		<td align='right' >Password: </td>
		<td align='left' >
			<input name='PWD' type="password" required value={webuser.PWD} onChange={(e)=>{webuserChange(e);}} autoComplete='off' placeholder='password' />
			&nbsp;{pwd.ok==true && <img src="img/greentick.png" height="14" border="0" />}
		</td>
		</tr>
		<tr>
		<td align='center' colSpan="2" >
		requirements: length 6 - 25 with  Capital & Common letter(s) & Number(s)
		</td>
		</tr>
		<tr>
		<td align='right' >Full Name: </td>
		<td align='left' ><input name='FULLNAME' type="text" required value={webuser.FULLNAME}  onChange={(e)=>{webuserChange(e);}} autoComplete='off' placeholder='full name' /></td>
		</tr>
		<tr>
		<td align='right' >10 digit Phone #: </td>
		<td align='left' ><input name='PHONE' type="tel" pattern="[0-9]{10}" required value={webuser.PHONE} onChange={(e)=>{webuserChange(e);}} autoComplete='off' placeholder='10 digit Phone #'   /></td>
		</tr>
		<tr>
		<td align='right' >Agency Name (if applicable): </td>
		<td align='left' >
		<select name='AGENCYID' required value={webuser.AGENCYID} onChange={(e)=>{webuserChange(e);}} >
		{agencyoptions}
		</select>
		</td>
		</tr>
		<tr>
		<td align='right' >Identification: </td>
		<td align='left' ><select name='ID_TYPE' required value={webuser.ID_TYPE} title={webuser.ID_TYPE} onChange={(e)=>{webuserChange(e);}} >{idtype}</select></td>
		</tr>
		{/*
		<tr>
		<td align='right' >Identification #: </td>
		<td align='left' ><input  name="PASSP_OR_ID_NBR" value={webuser.PASSP_OR_ID_NBR} onChange={(e)=>{webuserChange(e);}}  placeholder='Passport # or Id card #'  autoComplete='off' /></td>
		</tr>
pattern="[0-9]{10}"		
		*/}

		<tr>
		<td align='center' colSpan="2" >valid Passport or TCI photo identificaiton (accepted file formats: png, jpg, jpeg, bmp, webp, gif):</td>
		</tr>

		<tr>
		{/*<td align='right' >&nbsp;</td>*/}
		<td align='center' colSpan="2" ><input  type="file" name='regfile' id='regfile' accept=".png,.jpg,.jpeg,.bmp,.webp,.gif" required onChange={(e)=>{selectedFilesChange(e);}}  /></td>
		</tr>

			{webuser.STAMP=='' &&
			<tr>
			<td align="right" style={{paddingRight:"9px"}} >
			<a href="#" onClick={(e)=>{e.preventDefault();navigate("/");}} className="nodecor"  >return to login page</a>
			</td>
			<td align='center'  >
			{dowait.show && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
			{!dowait.show && <button className="button" >submit registration form</button>}
			</td>
			</tr>		
			}
		</tbody>
		</table>

		{/*
		<div align="center">
		before you can login, your registration information need be verified by an official
		</div>
		*/}
		</form>
	</div>

	<div id="confirm" className="tabcontent" style={{marginTop:"60px"}} >
	<p align='center' ><img src="img/greentick.png" border="0" />&nbsp;Thank you for registering!</p>
	<p align='center' >you can login and start submitting applications.\r\nRead the pdf document first</p>
	<p align='center' ><a href="#" onClick={(e)=>{e.preventDefault(); navigate("/login"); }}>click here to return to login page</a></p>
	</div>

<div id="snackbar">&nbsp;</div>
    </>
  );
  


};


export default RenderWpForm;